import { render } from "./HomepageUniversiteitgent.vue?vue&type=template&id=a77728a8&scoped=true"
import script from "./HomepageUniversiteitgent.vue?vue&type=script&lang=js"
export * from "./HomepageUniversiteitgent.vue?vue&type=script&lang=js"

import "./HomepageUniversiteitgent.vue?vue&type=style&index=0&id=a77728a8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a77728a8"]])

export default __exports__